import { useNavigate } from "react-router-dom";

export default function ParentPage() {
  const navigate = useNavigate();
  
  return (
    <div style={{ padding: 24 }}>
      <h1 
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/dashboard')}
        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
      >
        <img src="/favicon.svg" alt="" style={{ height: 24, width: 24, verticalAlign: 'text-bottom', marginRight: 8 }} /> GoutDeau Parent Dashboard
      </h1>
      <p>Track your family's hydration habits and health goals.</p>
      
      <div style={{ marginTop: 24, padding: 24, border: "1px solid #e5e7eb", borderRadius: 8 }}>
        <h2>🚧 Family Water Tracking Coming Soon</h2>
        <p>This page will help you monitor your family's hydration habits.</p>
        <p>Features will include:</p>
        <ul>
          <li>Family member water intake tracking</li>
          <li>Progress monitoring and insights</li>
          <li>Hydration goals and reminders</li>
          <li>Family challenges and achievements</li>
          <li>Health tips and recommendations</li>
        </ul>
      </div>
    </div>
  );
}